export const BackofficeLayoutConstants = {
  BACKOFFICE_COLLAPSED_SIDER_WIDTH: 50,
  BACKOFFICE_SIDER_WIDTH: 200,
} as const
